<template>
  <div>
     <div class="footer">
          <div class="end-text">
              <ul>
                <li>Copyright {{year}} All Rights Reserved Powered by Chongwen Academy</li>
                <li>浙ICP备15006741号-3</li>
                <li>{{address}}</li>
                <li>TEL.{{tel}}</li>
              </ul>
          </div>
      </div>
  </div>
</template>
<script>
export default {
  name:'Footer',
  data(){
    return{
      tel:'',
      address:'',
      year:''
    }
  },
  methods:{
      getList () {
      this.$http.post('/api/footer/getInfo', {
        }).then( (res)=> {
   
        var code=res.data.code;
        if(code===0){
          this.tel=res.data.data.contact.tel
          this.address=res.data.data.contact.address
        }
      }).catch(function (error) {
        //  console.log(error);
     });
  },
  },
  created(){
    // this.getList();
    var time=new Date();
    this.year=time.getFullYear()

    // console.log(this.year)
  }
}
</script>
<style scoped>
.footer{
  margin: 0 auto;
  background: url('../assets/footer_02.png');
  width: 100%;
  min-width: 1200px;
  height: 336px;
  background-size: cover;
  background-position: center center;
  background-repeat:no-repeat;
  /* position: absolute; */

}
.end-text{
  width:  63%;
  text-align: right;
  z-index: 100;
  line-height: 2vw;
  /* float:right; */
  margin: 0 auto;
  position: relative;
  top:50%;

}

.end-text ul li{
  list-style: none;
  font-size: .75rem;
  color: rgb(137, 102,25)
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue